var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boxes-row"},_vm._l((_vm.boxes),function(box){return _c('div',{key:box.idNews,class:_vm.boxClass},[_c('NewsBox',{attrs:{"news":box}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }